import { Stack } from '@talos/kyoko';
import { OrderRequestChangedBanner } from '../../components/OrderRequestChangedBanner';
import { useOrderRequestChanged } from '../../hooks/useOrderRequestChanged/useOrderRequestChanged';
import type { PreTradeResponseData } from '../../redux/preTradeApi';
import { OrderTrajectory } from './OrderTrajectory/OrderTrajectory';
import { PublicMarkets } from './PublicMarkets/PublicMarkets';
import { StrategySummary } from './StrategySummary/StrategySummary';
import { TotalCostRisk } from './TotalCostRisk/TotalCostRisk';
import { PreTradePredictions } from './TradePredictions/PreTradePredictions';

interface DetailsTabProps {
  scenario: PreTradeResponseData;
  showNonConsidered: boolean;
  isActiveSession: boolean;
}

export function DetailsTab({ scenario, showNonConsidered, isActiveSession }: DetailsTabProps) {
  const hasOrderRequestChanged = useOrderRequestChanged(scenario);

  return (
    <Stack alignItems="stretch" gap="spacing8">
      {hasOrderRequestChanged && <OrderRequestChangedBanner isActiveSession={isActiveSession} />}
      <Stack gap="spacing16" alignItems="stretch" p="spacing16">
        <StrategySummary scenario={scenario} showNonConsidered={showNonConsidered} />
        <TotalCostRisk scenario={scenario} />
        <PreTradePredictions scenario={scenario} />
        <OrderTrajectory scenario={scenario} />
        <PublicMarkets scenario={scenario} />
      </Stack>
    </Stack>
  );
}
